import './style/index.less';
import PersonaCollectItem from './PersonaCollectItem';

export default PersonaCollectItem;
